import _ from 'underscore';
import { useMemo } from 'react';
import { useWizardService, WIZARD_EVENTS, STEP_EVENTS } from '@bingads-webui-react/wizard';
import { useNavigationConfirmationPrompt } from '@bingads-webui-campaign-react/step-wizard';


const EXIT_WITHOUT_SAVING_MESSAGE_KEY = _TL_('Your latest changes have not been saved. Do you want to continue without saving changes?');

export const useExitWithoutSavingConfirmation = (i18n, confirmationMessage = undefined) => {
  const { state } = useWizardService();

  const exitConfirmationMessage = useMemo(() => confirmationMessage || i18n.getString(EXIT_WITHOUT_SAVING_MESSAGE_KEY), [i18n, confirmationMessage]);
  const navigationConfirmationPrompt = useNavigationConfirmationPrompt(!_.contains([WIZARD_EVENTS.CANCEL, STEP_EVENTS.SYNC_SAVED], state.event.type), exitConfirmationMessage);

  return [navigationConfirmationPrompt];
};
